import React from 'react';
import './Footer.css';

export default function Footer() {
	return (
		<footer className='footer'>
			<div className='footer__inner'>
				<p className='footer__copy'>
					© {new Date().getFullYear()} Apiary Consulting LLC · Portland, OR
				</p>
				<div className='footer__links'>
					<a href='/privacy'>Privacy</a>
					<a href='/terms'>Terms</a>
				</div>
			</div>
		</footer>
	);
}
